import React from 'react'

import { Portlet, Table, Row, Col, Form } from '_zari/core'

import * as InventarioService from 'services/inventario.service'

const portletBreadcrumbs = [{ name: 'Reporte x Producto' }]

const ReportePorProductoPage = ({ match }) => {
  const [infoProducto, setInfoProducto] = React.useState(null)

  React.useEffect(() => {
    InventarioService.getReportePorProducto(match.params.idProducto).then(({ data }) => {
      setInfoProducto(data)
    })
  }, [match.params.idProducto])

  return (
    <>
      {infoProducto && (
        <Portlet>
          <Portlet.Header title='Reporte x Producto' breadcrumbs={portletBreadcrumbs} />
          <Portlet.Body>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label text='PRODUCTO' md={3} alignRightAt='md' />
                  <Col md={3}>
                    <Form.InputText
                      id='readonly-producto'
                      name='readonly-producto'
                      defaultValue={`${infoProducto.codigoProducto} - ${infoProducto.nombreProducto}`}
                    />
                  </Col>
                </Form.Group>
                <Form.Group>
                  <Form.Label text='TOTAL ENTRADA' md={3} alignRightAt='md' />
                  <Col md={3}>
                    <Form.InputText
                      id='readonly-totalEntrada'
                      name='readonly-totalEntrada'
                      defaultValue={infoProducto.totalEntrada}
                    />
                  </Col>
                </Form.Group>
                <Form.Group>
                  <Form.Label text='TOTAL SALIDA' md={3} alignRightAt='md' />
                  <Col md={3}>
                    <Form.InputText
                      id='readonly-totalSalida'
                      name='readonly-totalSalida'
                      defaultValue={infoProducto.totalSalida}
                    />
                  </Col>
                </Form.Group>
                <Form.Group>
                  <Form.Label text='TOTAL SALDO' md={3} alignRightAt='md' />
                  <Col md={9}>
                    <Form.InputText
                      id='readonly-totalSaldo'
                      name='readonly-totalSaldo'
                      defaultValue={infoProducto.totalSaldo}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Table
              className='text-center'
              maxRowsShown={10}
              filas={infoProducto.detalles}
              headRows={[
                { label: 'FECHA', width: 1 },
                { label: 'TIPO', width: 35 },
                { label: 'SERIE', width: 35 },
                { label: 'NRO', width: 35 },
                { label: 'TIPO OPE', width: 50 },
                // { label: 'CANTIDAD', width: 60 },
                // { label: 'EQUIV.', width: 50 },
                // { label: 'UNIDAD', width: 50 },
                { label: 'INGRESO', width: 55 },
                { label: 'SALIDA', width: 55 },
                { label: 'SALDO', width: 55 },
                { label: 'SOCIO', width: 100 },
                { label: 'RUC', width: 100 }
              ]}
              rowTemplate={row => (
                <Table.Row hover key={row._id}>
                  <Table.Cell className='text-center'>{row.fechaEmision || '--'}</Table.Cell>
                  <Table.Cell className='text-center'>{row.tipoDocumento || '--'}</Table.Cell>
                  <Table.Cell className='text-center'>{row.serieDocumento || '--'}</Table.Cell>
                  <Table.Cell className='text-center'>{row.numeroDocumento || '--'}</Table.Cell>
                  <Table.Cell className='text-center'>{row.tipoOperacion || '--'}</Table.Cell>
                  {/* <Table.Cell className='text-center'>{row.cantidad || '--'}</Table.Cell>
                  <Table.Cell className='text-center'>{row.equivalencia || '--'}</Table.Cell>
                  <Table.Cell className='text-center'>{row.unidadDeMedida || '--'}</Table.Cell> */}
                  <Table.Cell className='text-center'>
                    {row.montoEntrada ? `${row.cantidad} ${row.unidadDeMedida} x ${row.equivalencia}` : '--'}
                  </Table.Cell>
                  <Table.Cell className='text-center'>
                    {row.montoSalida ? `${row.cantidad} ${row.unidadDeMedida} x ${row.equivalencia}` : '--'}
                  </Table.Cell>
                  <Table.Cell className='text-center'>{row.sumaConjunta || '--'}</Table.Cell>
                  <Table.Cell className='text-center'>{row.razonSocial || '--'}</Table.Cell>
                  <Table.Cell className='text-center'>{row.rucSocio || '--'}</Table.Cell>
                </Table.Row>
              )}
            />
          </Portlet.Body>
        </Portlet>
      )}
    </>
  )
}

export default React.memo(ReportePorProductoPage)
